import React from 'react';

const logoSrc = `${process.env.PUBLIC_URL || ''}/aurasphere-logo.svg`;

function Loading() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-void px-6" data-testid="loading">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="rounded-2xl p-3">
          <img
            src={logoSrc}
            alt="AuraSphere"
            className="h-32 w-32 object-contain"
          />
        </div>
        <div>
          <h1 className="font-display text-2xl font-semibold tracking-wide text-ash">
            AuraSphere
          </h1>
          <p className="mt-1 text-sm text-silver">Gathering your aura...</p>
        </div>
        <div
          className="mt-1 h-8 w-8 animate-spin rounded-full border-4 border-aura/25 border-t-ether"
          aria-label="Loading"
        />
      </div>
    </div>
  );
}

export default Loading;
